import { gql } from "@apollo/client";

export const GET_USER_PROFILE = gql`
  query GetUserProfile($id: ID!) {
    user(id: $id) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      desc
      defaultBusinessId
      defaultPageId
      timeZone {
        id
        timezone
      }
    }
  }
`;
